import React, { useState } from 'react';

type Props = {
  name: string;
  color: string;
  onRemoveChip?: (name: string) => void;
  canRemove?: boolean;
  canEdit?: boolean;
  onUpdateChip?: (arg: { name: string; updatedName: string }) => void;
};

const Chip: React.FC<Props> = ({
  name,
  color,
  onRemoveChip,
  canRemove = false,
  canEdit = false,
  onUpdateChip
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [updatedName, setUpdatedName] = useState(name);

  const handleTagClick = () => {
    if (canEdit) {
      setIsEditing(true);
    }
  };

  const handleSave = () => {
    setIsEditing(false);
    if (onUpdateChip && updatedName !== name) {
      onUpdateChip({ name: name, updatedName: updatedName });
    }
  };

  const handleCancel = () => {
    setUpdatedName(name);
    setIsEditing(false);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedName(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSave();
    } else if (event.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <span
      className="custom-chip-container"
      style={{
        backgroundColor: `#${color}`,
        color: 'white',
        display: isEditing ? 'flex' : undefined
      }}
      onClick={handleTagClick}
    >
      {isEditing ? (
        <span>
          <input
            type="text"
            value={updatedName}
            onBlur={handleSave}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </span>
      ) : (
        name
      )}
      {canRemove && (
        <button type="button" onClick={() => onRemoveChip?.(name)}>
          &times;
        </button>
      )}
    </span>
  );
};

export default Chip;
